export default __webpack_public_path__ + "static/media/volvo.e11d67c8.png";